import { axios } from "../http-common";

class Recipient {
  recipientList(data) {
    return axios.get("v1/member/transfer/get-recepient-list", { params: data });
  }
  addRecipient(data) {
    return axios.post("v1/member/transfer/add-recepient", data);
  }
}

export default new Recipient();
